import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import React, { FunctionComponent } from 'react';

import Breadcrumbs from '../../modules/breadcrumbs';
import FooterUpperCurve from '../../modules/footer/footer-upper-curve';
import PageTitle from '../../ui/typography/page-title';

import FaqsList from './faqs-list';
import FaqSchema from './seo';

const FaqsPage: FunctionComponent<TPageFaqsByGroup> = ({
  faqsByGroup,
  faqsForSchema,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <FaqSchema breadcrumbs={[]} faqsForSchema={faqsForSchema} />
      <Breadcrumbs items={[]} currentPage={t('common:faqs')} />
      <div
        className={cx(
          'container',
          'grid',
          'lg:grid-cols-3',
          'mx-auto',
          'lg:my-12',
          'my-4'
        )}
      >
        <div className="pl-4 mb-6 lg:mb-0 lg:col-span-2">
          <PageTitle title={t('common:faqs')} />
          <p className="text-sm ">{t('faqs:description')}</p>
        </div>
        <FaqsList faqsByGroup={faqsByGroup} />
      </div>
    </>
  );
};

export default FaqsPage;
